// РИМСКИЕ НОМЕРА ЭТАПОВ I…XV — один список на продукт.
//
// ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ. Список из пятнадцати литералов лежал в репо шестью копиями, и все шесть
// принадлежали рендеру паспорта. Шаг 3 — первый потребитель ИЗ ВИЗАРДА (стена финала печатает
// `Cards I, II and III`), то есть первая копия, которая появилась бы за пределами `src/render/`.
// Заводить седьмую, чтобы визард не импортировал из рендера, было бы худшим из выходов: номер
// этапа — это одна величина продукта, а не деталь чарта.
//
// ⚠️ ПЕРЕВЕДЕНА ТОЛЬКО ОДНА КОПИЯ — `SevenLayersChart.jsx` (так сказано в скоупе B5-1). Пять
// остальных (`SectionV.jsx`, `SectionVI.jsx`, `viewFromPassport.js`, `sectionIIIBoards.js`,
// `sectionVIBoards.js`) и седьмая, другой формы (`SectionII.jsx` — с пустым нулевым элементом,
// счёт с единицы), НЕ тронуты намеренно: секции паспорта — байт-парити зона, и правка шести
// запиненных файлов ради одного нового импорта стоит дороже, чем называется. Долг живёт здесь
// строкой, а не в памяти — тот же приём, что у карты `NUMW` в `steps/stageGate.js`.
//
// ПОТОЛОК — ПЯТНАДЦАТЬ, и это не запас, а потолок визарда: `MAX_STAGES` шага 2. Выше номера
// физически не бывает, поэтому список — литерал, а не генератор римской записи: генератор здесь
// добавил бы код и ни одного нового значения.

/** Римские номера этапов I…XV по индексу с нуля. Порядок и состав — как у рендера паспорта. */
export const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV'];

/**
 * Римский номер этапа по индексу с нуля.
 *
 * За потолком возвращает `''`, а не `undefined`: строка, собранная из номеров, при `undefined`
 * напечатала бы слово «undefined» человеку. Тот же выбор уже сделан в `SectionVI.jsx`.
 */
export const roman = (i) => ROMAN[i] || '';
